// extracted by mini-css-extract-plugin
export default {"viewNotesModal":"ViewNotes_viewNotesModal__HyEY3"};